// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Logout_wrapper__2v-9c"};